import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { BACKEND_URL } from '../../utils/config';
import { setAuth, consumePostLoginRedirect } from '../../utils/authStorage';
import { AuthPage } from './AuthShell';
import './LoginPage.css';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | pending | error
  const [error, setError] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setStatus('error'); setError('No verification token provided'); return; }

    fetch(`${BACKEND_URL}/api/auth/verify?token=${encodeURIComponent(token)}`)
      .then(r => r.json())
      .then(data => {
        if (data.success && data.token) {
          setAuth({ token: data.token, user: data.user, remember: true });
          // A pending account is let in too: the app shows the holding
          // screen until an admin approves it.
          setStatus(data.pendingApproval ? 'pending' : 'success');
          // Honour any deep-link that bounced through sign-up (e.g. an
          // invite link) — without this the verifier sent invitees back
          // to "/" and they lost the invite they just signed up for.
          setTimeout(() => navigate(consumePostLoginRedirect()), 2000);
        } else {
          setStatus('error');
          setError(data.error || 'Verification failed');
        }
      })
      .catch(() => { setStatus('error'); setError('Cannot connect to server'); });
  }, []);

  return (
    <AuthPage>
      {status === 'verifying' && <p className="login-subtitle">Verifying your email...</p>}
      {status === 'success' && (
        <div className="login-verify">
          <svg className="login-verify-icon login-verify-icon--success" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
          </svg>
          <h2>Email verified!</h2>
          <p>Redirecting you to your projects...</p>
        </div>
      )}
      {status === 'pending' && (
        <div className="login-verify">
          <svg className="login-verify-icon login-verify-icon--pending" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
          </svg>
          <h2>Email verified</h2>
          <p>Your account is waiting for pidly to approve it. Taking you in...</p>
        </div>
      )}
      {status === 'error' && (
        <div className="login-verify">
          <svg className="login-verify-icon login-verify-icon--error" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
          <h2>Verification failed</h2>
          <p>{error}</p>
          <button className="login-submit-btn" onClick={() => navigate('/login')}>Back to Sign In</button>
        </div>
      )}
    </AuthPage>
  );
}
